export const SOURCE_TYPES = {
  CTA: 'cta',
  LOGGEDIN_METASEARCH: 'loggedInMetasearch',
  METASEARCH: 'metasearch',
} as const
